import React, {Component} from "react";

export class ClaimStepsLayout extends Component {
    render() {
        const {children, style} = this.props

        return (
            <div className="member-main-container" style={{...style, background: 'white', paddingBottom: 360}}>
                {children}
            </div>
        )
    }
}